import Vue from 'vue';
import moment from 'moment';

Vue.filter('dateFormat', (date: string, addHours = 3) => {
  return moment(date).add(addHours, 'hours').format('DD.MM.YYYY, HH:mm');
});
